import { render, staticRenderFns } from "./MessageTypeRecipientsAdded.vue?vue&type=template&id=1ea088ad&scoped=true&"
import script from "./MessageTypeRecipientsAdded.vue?vue&type=script&lang=js&"
export * from "./MessageTypeRecipientsAdded.vue?vue&type=script&lang=js&"
import style0 from "./MessageTypeRecipientsAdded.vue?vue&type=style&index=0&id=1ea088ad&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ea088ad",
  null
  
)

export default component.exports